import { render, staticRenderFns } from "./_DeleteAttachedFile.vue?vue&type=template&id=6530d544"
import script from "./_DeleteAttachedFile.vue?vue&type=script&lang=js"
export * from "./_DeleteAttachedFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports